/**
* 订单管理 交易订单
*/
<template>
    <div id="balanceBox">

        <div class="header">
            <!-- 面包屑导航 -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>余额明细列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 搜索 -->
        <div class="searchBox">
            <!-- 搜索筛选 -->
            <el-form :inline="true" class="user-search">
                <el-form-item>
                    <el-input size="small" v-model="userName" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size="small" v-model="mobile" placeholder="请输入用户手机号"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="type" placeholder="请选择类型">
                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="nr">
            <!--列表-->
            <el-table height="100%" size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;" v-horizontal-scroll>
                <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="userName" label="用户名称"
                    width="140"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="title" label="标题"
                    width="200"></el-table-column>
                <el-table-column align="center" prop="type" label="类型" width="200">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type == 0">增加</div>
                        <div v-if="scope.row.type == 1">扣除</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="phone" show-overflow-tooltip label="电话号码"
                    width="140"></el-table-column>
                <el-table-column align="center" prop="amount" show-overflow-tooltip label="明细" width="200">
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <div v-if="scope.row.type == 0">增加</div>
                            <div v-if="scope.row.type == 1">扣除</div>
                            <div>{{ scope.row.amount }}</div>
                            <div v-if="scope.row.category == 0">奖学金</div>
                            <div v-if="scope.row.category == 1">钻石</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="befores" show-overflow-tooltip label="变化前余额"
                    width="130"></el-table-column>
                <el-table-column align="center" prop="afters" show-overflow-tooltip label="变化后余额"
                    width="130"></el-table-column>
                <el-table-column align="center" sortable min-width="120" prop="createTime" label="创建时间"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div>{{ transformDate(scope.row.createTime) }}</div>
                    </template>
                </el-table-column>

            </el-table>

        </div>

        <!-- 分页组件 -->
        <div class="pagingBox">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>

    </div>
</template>

<script>
import { getUserBalanceList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            loading: false, //是显示加载
            editFormVisible: false, //控制编辑页面显示与隐藏
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            },
            userName: '',
            mobile: '',
            type: -1,
            options: [
                {
                    value: -1,
                    label: '全部'
                }, {
                    value: 0,
                    label: '增加'
                }, {
                    value: 1,
                    label: '扣除'
                }
            ]
        }
    },
    // 注册组件
    components: {
        Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {

        this.getOrderList(1)


    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

        // 获取订单列表
        getOrderList(page) {
            this.loading = true;
            var parameter = {
                page: (page - 1) * 20,
                type: this.type,
                userName: this.userName,
                mobile: this.mobile,
            };
            getUserBalanceList(parameter).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.listData = res.data.list
                    this.pageparm.currentPage = page
                    this.pageparm.total = res.data.count
                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            });
        },

        // 分页插件事件
        callFather(parm) {
            this.getOrderList(parm.currentPage)
        },
        // 搜索事件
        search() {
            this.getOrderList(1)
        },
        // 重置数据
        chongzhi() {
            this.userName = ''
            this.mobile = ''
            this.type = -1
            this.getOrderList(1)
        },
        //显示编辑界面
        handleEdit: function (index, row) {
            this.editFormVisible = true
            this.orderInfo = row;
            this.getOrderDetails()
        },


    }
}
</script>

<style scoped>
.user-search {
    margin-top: 20px;
}

.userRole {
    width: 100%;
}

#balanceBox{
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
}
#balanceBox .header{
    flex: none;
}
#balanceBox .searchBox{
    flex: none;
}
#balanceBox .nr{
    flex: auto;
    overflow: auto;
}
#balanceBox .pagingBox{
    flex: none;
}

</style>


// WEBPACK FOOTER //
// src/views/pay/walletBalanceDetails.vue